// Enum of the three customer-level date format tokens.
// These values are set in Customer#customer_settings_date_format (CustomerSettings table)
// and are used throughout the app to drive date/datetime formatting in both Ruby
// (Customer#abbrev_date_format) and JS (shared/date_time_format.js).
const CustomerDateFormat = Object.freeze({
  MDY: 'MDY',
  YMD: 'YMD',
  DMY: 'DMY',
})

export default CustomerDateFormat
